import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuildingimagesLinkComponent } from './buildingimages-link/buildingimages-link.component';
import { BuildingImagesComponent } from './building-images/building-images.component';

const routes: Routes = [
   {
      path:'',component:BuildingimagesLinkComponent,
      children:[
        {
          path:'BuildingData',component:BuildingImagesComponent
        },
      ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BuildingImagesRoutingModule { }
